import * as React from 'react';
import {
	Dialog, DialogType, DialogFooter,
	Button, ButtonType
} from 'office-ui-fabric-react';

interface IProps {
	onOKClick: () => void;
	onCancelClick: () => void;
	title: string;
	message: string;
	isOpen: boolean;
	isCancelButtonHidden: boolean;
	okButtonLabel?: string;
	cancelButtonLabel?: string;
}

export class ConfirmationDialog extends React.Component<IProps, any> {

	public render() {

		let { title, message, okButtonLabel, cancelButtonLabel, isCancelButtonHidden, isOpen, onOKClick, onCancelClick } = this.props;

		return (
			<div>
				<Dialog
					isOpen={isOpen}
					type={DialogType.largeHeader}
					onDismiss={() => onCancelClick()}
					title={title}
					isBlocking={false}>

					<p>{message}</p>

					<DialogFooter>
						<Button buttonType={ButtonType.primary} onClick={() => onOKClick()}>{okButtonLabel || 'OK'}</Button>
						{isCancelButtonHidden ? null : <Button buttonType={ButtonType.normal} onClick={() => onCancelClick()}>{cancelButtonLabel || 'Cancel'}</Button>};
					</DialogFooter>
				</Dialog>
			</div>
		);

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/layout/confirmation-dialog.tsx